<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">
          노선그룹 관리
          <v-btn v-if="$store.state.userInfo && $store.state.userInfo.writeBus" @click="setCreateMode" depressed rounded outlined color="secondary" class="ml-5">
            <v-icon>add</v-icon> 노선그룹 추가
          </v-btn>
        </h1>
        <!--<p class="content&#45;&#45;empty" v-if="true">등록된 노선그룹이 없습니다.</p>-->
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="routeGroupList && routeGroupList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(routeGroup, idx) in routeGroupList"
                      :key="idx"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentRouteGroup(routeGroup)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ routeGroup.name }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="routeGroupList && routeGroupList.length === 0">등록된 노선그룹이 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-if="routeGroup && routeGroup.id || mode === 'CREATE'"
                  >
                    <v-container class="pa-lg-10 pt-lg-7">
                      <v-row class="pa-2">
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">이름*</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-5">
                          <v-text-field
                            v-model="routeGroup.name"
                            hide-details
                            class="pa-0 pt-0"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">지역</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-5">
                          <v-text-field
                            v-model="routeGroup.district"
                            hide-details
                            class="pa-0 pt-0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <v-subheader class="pa-0 form-label--separate">담당자</v-subheader>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-0">
                          <v-select
                            v-model="routeGroup.manager"
                            :items="managerList"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" class="pa-0 mb-0">
                          <v-checkbox
                            v-model="routeGroup.visible"
                            label="앱에 표시하기"
                          ></v-checkbox>
                        </v-col>
<!--                        <v-col cols="12" class="pa-0 pt-2">-->
<!--                          <v-subheader class="pa-0 form-label&#45;&#45;separate">정류장</v-subheader>-->
<!--                        </v-col>-->
<!--                        <v-col cols="12">-->
<!--                          <v-list class="content-list">-->
<!--                            <v-list-item-group  color="primary">-->
<!--                              <v-list-item-->
<!--                                v-for="(it, i) in (stationList || []).filter(x => x.remove !== true)"-->
<!--                                :key="i"-->
<!--                                inactive-->
<!--                                class="content-list__item"-->
<!--                                :ripple="false"-->
<!--                              >-->
<!--                                <div class="content-list-text-content">-->
<!--                                  <v-list-item-content>-->
<!--                                    <v-list-item-title>-->
<!--                                      <v-row class="pa-2">-->
<!--                                        <v-col cols="6">-->
<!--                                          <v-text-field-->
<!--                                            v-model="it.name"-->
<!--                                            label="정류장이름"-->
<!--                                            hide-details></v-text-field>-->
<!--                                        </v-col>-->
<!--                                        <v-col cols="2" class="pa-0 pt-6 flex align-center">-->
<!--                                          <v-btn color="black" dark small rounded depressed  @click="onOpenLocationModal(i)">-->
<!--                                            위치-->
<!--                                            <v-icon small>map</v-icon>-->
<!--                                          </v-btn>-->
<!--                                        </v-col>-->
<!--                                        <v-col cols="4">-->
<!--                                          <div>created : {{ it.createdDate }}</div>-->
<!--                                          <div>updated : {{ it.updatedDate }}</div>-->
<!--                                        </v-col>-->
<!--                                      </v-row>-->
<!--                                    </v-list-item-title>-->
<!--                                  </v-list-item-content>-->
<!--                                  <v-list-item-action v-if="$store.state.userInfo && $store.state.userInfo.writeBus">-->
<!--                                    <v-btn @click="removeStation(i)" small outlined rounded color="error">삭제</v-btn>-->
<!--                                    &lt;!&ndash;<v-btn @click="onUpdateStation(i)" small outlined rounded color="primary" class="ml-1">수정</v-btn>&ndash;&gt;-->
<!--                                  </v-list-item-action>-->
<!--                                </div>-->
<!--                                <div class="content-list-image-content">-->
<!--                                  <carousel-->
<!--                                    :key="it.id"-->
<!--                                    :index="i"-->
<!--                                    :image-object.sync="it.stationImage"-->
<!--                                    :is-show-remove-button="$store.state.userInfo && $store.state.userInfo.writeBus"-->
<!--                                  />-->
<!--                                </div>-->
<!--                                &lt;!&ndash;<v-file-input accept="image/*" multiple></v-file-input>&ndash;&gt;-->
<!--                              </v-list-item>-->
<!--                            </v-list-item-group>-->
<!--                          </v-list>-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="pa-0">-->
<!--                          <v-btn-->
<!--                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"-->
<!--                            class="ml-3" dark depressed small color="secondary" rounded outlined-->
<!--                            @click="addStation"-->
<!--                          >-->
<!--                            <v-icon dark>mdi-plus</v-icon> 정류장 추가-->
<!--                          </v-btn>-->
<!--                        </v-col>-->
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                            color="primary"
                            class="mt-4"
                            rounded
                            depressed
                            @click="onSubmit"
                            large
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기'}}
                          </v-btn>
                        </v-col>
                        <v-col class="mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus && routeGroup.id"
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveRouteGroup">
                            <v-icon>remove</v-icon>
                            노선그룹제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 노선그룹이 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
    <!-- 주차장 입구 위경도 설정 팝업-->
    <v-dialog v-model="locationModal" fullscreen hide-overlay transition="dialog-bottom-transition" class="map-layer">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>노선관리 - 위치 설정</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0">
          <map-pick
            v-if="locationModal"
            :location-data="locationData"
            :index="mapPickIndex"
            @closeModal="closeModal"
            @onSubmitMapPick="getLocation"
            :is-show-set-button="$store.state.userInfo && $store.state.userInfo.writeBus"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </article>
</template>

<script>
import eventBus from '../utils/eventBus'
import Carousel from '../components/common/Carousel'
import MapPick from '../components/map/MapPick'
import { image, manager, routeGroup, station } from '../api'

export default {
  components: {
    // Carousel,
    MapPick
  },
  data: () => ({
    routeGroupList: null,
    routeGroup: {},
    stationList: [],
    stationName: '',
    locationData: null,
    mapPickIndex: -1,
    mode: null,
    activeIndex: null,
    locationModal: false,
    managerList: []
  }),
  created () {
    this.fetchList()
    this.fetchManagerList()
  },
  methods: {
    async fetchManagerList () {
      const { data } = await manager.list()
      this.managerList = data.map(x => {
        return {
          text: `${x.name} (${x.phone})`,
          value: x.id
        }
      }, [])
    },
    async fetchList () {
      const { data } = await routeGroup.list()
      this.routeGroupList = data
    },
    async onSubmit () {
      try {
        eventBus.$emit('showLoading')
        let data
        if (this.mode === 'CREATE') {
          data = await this.createRouteGroup()
          eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
        }
        if (this.mode === 'UPDATE') {
          data = await this.updateRouteGroup()
          eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
        }
        await this.fetchList()
        const index = this.routeGroupList.findIndex(x => x.id === data.id)
        this.selectMainItem(index)
        await this.setCurrentRouteGroup(this.routeGroupList[index])
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async createRouteGroup () {
      const { data } = await routeGroup.create(this.routeGroup)
      // 정류장
      for (const i in this.stationList) {
        const targetStation = this.stationList[i]
        await this.processAddImage(targetStation.stationImage)
        await this.processDeleteImage(targetStation.stationImage)
        await station.create({
          ...targetStation,
          routeGroup: data.id,
          images: targetStation.stationImage.images
        })
      }
      return data
    },
    async updateRouteGroup () {
      const { data } = await routeGroup.set(this.routeGroup.id, this.routeGroup)
      for (const i in this.stationList) {
        const targetStation = this.stationList[i]
        if (targetStation.remove) {
          await station.delete(targetStation.id)
        } else if (targetStation.id === 0) {
          await this.processAddImage(targetStation.stationImage)
          await this.processDeleteImage(targetStation.stationImage)
          await station.create({
            ...targetStation,
            routeGroup: data.id,
            images: targetStation.stationImage.images
          })
        } else {
          await this.processAddImage(targetStation.stationImage)
          await this.processDeleteImage(targetStation.stationImage)
          await station.set(targetStation.id, {
            ...targetStation,
            routeGroup: data.id,
            images: targetStation.stationImage.images
          })
        }
      }
      return data
    },
    async addStation () {
      const defaultData = {
        id: 0,
        stationImage: {
          images: [],
          deleteTarget: [],
          addTarget: []
        }
      }
      if (!this.stationList) {
        this.stationList = [defaultData]
      } else {
        this.stationList.push(defaultData)
      }
    },
    async removeStation (index) {
      if (this.stationList[index].id === 0) {
        this.stationList.splice(index, 1)
      } else {
        this.$set(this.stationList.filter(x => x.remove !== true)[index], 'remove', true)
      }
    },
    async processAddImage (imageObject) {
      for (const i in imageObject.addTarget) {
        const { data } = await image.create(this.makeFileFormData(imageObject.addTarget[i].file))
        imageObject.images.push(data.name)
      }
      return imageObject
    },
    processDeleteImage (imageObject) {
      for (const i in imageObject.deleteTarget) {
        const imageIndex = imageObject.images.indexOf(imageObject.deleteTarget[i])
        imageObject.images.splice(imageIndex, 1)
      }
      return imageObject
    },
    makeFileFormData (file) {
      const formData = new FormData()
      formData.append('sourceFile', file)
      return formData
    },
    setCreateMode () {
      this.routeGroup = { id: 0 }
      this.stationList = []
      this.mode = 'CREATE'
      this.activeIndex = null
    },
    async setCurrentRouteGroup (routeGroup) {
      // 하위 스테이션 불러오기
      this.stationList = await this.fetchStationList(routeGroup.id)
      this.routeGroup = { ...routeGroup }
      this.mode = 'UPDATE'
    },
    async fetchStationList (routeGroupId) {
      const { data } = await station.list()
      return data.filter(x => x.routeGroup === routeGroupId)
        .map(x => {
          return {
            ...x,
            stationImage: {
              images: x.images,
              deleteTarget: [],
              addTarget: []
            }
          }
        }, [])
    },
    onRemoveRouteGroup () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '노선그룹을 정말 제거하시겠습니까?',
          okText: '노선그룹 제거',
          confirmHandler: {
            ok: async () => {
              await routeGroup.delete(this.routeGroup.id)
              eventBus.$emit('alert', { active: true, text: '삭제 되었습니다.' })
              this.setCreateMode()
              await this.fetchList()
            }
          }
        }
      )
    },
    onOpenLocationModal (index) {
      this.locationData = null
      this.mapPickIndex = index
      const station = this.stationList[index]
      if (station.lat > 0 && station.lng > 0) {
        this.locationData = {
          lat: station.lat,
          lng: station.lng
        }
      }
      this.locationModal = true
    },
    getLocation (location, index) {
      this.stationList[index].lat = location.lat
      this.stationList[index].lng = location.lng
      this.locationModal = false
      this.mapPickIndex = -1
      eventBus.$emit('alert', { active: true, text: '정류장 위치가 설정 되었습니다.' })
    },
    closeModal () {
      this.locationModal = false
    },
    selectMainItem (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
  .content-list {
    .v-list-item {
      border: 1px solid #e2e7eb;
      border-top: 0;
      &:first-child {
        border-top: 1px solid #e2e7eb;
      }
    }
    .content-list__item {
      display: flex;
      flex-direction: column;
    }
    .content-list-text-content {
      display: flex;
      width: 100%;
    }
    .content-list-image-content {
      width: 100%;
      .file-input-contents {
        padding: 0;
      }
    }
  }
  .v-list-item__action--stack {
    flex-direction: row;
  }
</style>
